import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  cursor: pointer;
  padding: .8rem 0;

  &:hover {
    background-color: ${props => props.theme.colors.background_hover};
  }

  span {
    margin-left: 1rem;
    font-size: 1rem;
    font-weight: 500;
  }

  & > .isSoon {
    font-size: .6rem;
    position: absolute;
    right: 0;
    border: 1px solid;
    padding: 3px;
    background: #a1a103;
    color: white;
    border-radius: 8px;
  }

  #chevron {
    margin-left: 6rem;
  }
`;

export const ItemBody = styled.div`
  ul {
    list-style: none;
    padding: 0 2rem;
    font-size: .85rem;  
    display: flex;  
    flex-direction: column;
    justify-content: center;

    li {
      font-weight: 500;
      color: #5d5d5d;
      padding: .6rem;
      cursor: pointer;
      position: relative;

      & > .isSoon {
        font-size: .6rem;
        position: absolute;
        right: -10px;
        top: 7px;
        border: 1px solid;
        padding: 3px;
        background: #a1a103;
        color: white;
        border-radius: 8px;
      }

      &:hover {
        background-color: ${props => props.theme.colors.background_hover};
      }
    }
  }
`;
